/* ==========================================================================
   SKYNZ Editorial — article behaviour
   File: assets/skynz-article.js

   1. Splits "Label | Heading" H2s into a numbered eyebrow + clean heading
   2. Builds the table of contents
   3. Reading progress bar
   4. Sticky CTA show/hide
   Degrades gracefully — the article reads fine if any of this fails.
   ========================================================================== */

(function () {
  'use strict';

  var MIN_HEADINGS = 3;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function slugify(text) {
    return text
      .toLowerCase().trim()
      .replace(/[\u2018\u2019\u201C\u201D]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  /* ---------- 1. "Label | Heading" -> eyebrow + heading ---------- */
  function splitHeadings() {
    var body = document.querySelector('[data-sk-body]');
    if (!body) return;

    var n = 0;
    Array.prototype.forEach.call(body.querySelectorAll('h2'), function (h) {
      var raw = h.textContent;
      if (raw.indexOf('|') === -1) return;

      var bits    = raw.split('|');
      var label   = bits.shift().trim();
      var heading = bits.join('|').trim();
      if (!label || !heading) return;

      n++;
      var eyebrow = document.createElement('div');
      eyebrow.className = 'sk-eyebrow';

      var num = document.createElement('span');
      num.className = 'sk-num';
      num.textContent = n;

      eyebrow.appendChild(num);
      eyebrow.appendChild(document.createTextNode(label));

      h.parentNode.insertBefore(eyebrow, h);
      h.textContent = heading;
    });
  }

  /* ---------- 2. Table of contents ---------- */
  function buildToc() {
    var toc = document.querySelector('[data-sk-toc]');
    if (!toc) return null;

    var headings = document.querySelectorAll('.sk-article h2[data-sk-h]');
    if (headings.length < MIN_HEADINGS) { toc.remove(); return null; }

    var list  = toc.querySelector('ol');
    var seen  = {};
    var links = [];

    Array.prototype.forEach.call(headings, function (h) {
      var base = slugify(h.textContent);
      var id = base, i = 2;
      while (seen[id]) { id = base + '-' + i; i++; }
      seen[id] = true;
      if (!h.id) h.id = id;

      var li = document.createElement('li');
      var a  = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      links.push({ link: a, heading: h });
    });

    toc.hidden = false;
    return links;
  }

  function trackActive(links) {
    if (!links || !('IntersectionObserver' in window)) return;
    var map = {};
    links.forEach(function (i) { map[i.heading.id] = i.link; });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        links.forEach(function (i) { i.link.classList.remove('is-active'); });
        var a = map[entry.target.id];
        if (a) a.classList.add('is-active');
      });
    }, { rootMargin: '-10% 0px -75% 0px', threshold: 0 });

    links.forEach(function (i) { obs.observe(i.heading); });
  }

  /* ---------- 3. Reading progress ---------- */
  function progress() {
    var bar     = document.querySelector('[data-sk-progress]');
    var article = document.querySelector('[data-sk-article]');
    if (!bar || !article) return;

    var ticking = false;

    function update() {
      var rect   = article.getBoundingClientRect();
      var total  = rect.height - window.innerHeight;
      var passed = -rect.top;
      var pct    = total > 0 ? (passed / total) * 100 : 0;
      bar.style.width = Math.min(100, Math.max(0, pct)) + '%';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- 4. Sticky CTA ---------- */
  function stickyCta() {
    var sticky = document.querySelector('[data-sk-sticky]');
    if (!sticky) return;
    sticky.hidden = false;

    var endCta = document.querySelector('.sk-cta-block');
    var endVisible = false;

    if (endCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        endVisible = e[0].isIntersecting;
        apply();
      }, { threshold: 0 }).observe(endCta);
    }

    var ticking = false;

    function apply() {
      var passed = window.scrollY > (window.innerHeight * 0.6);
      sticky.classList.toggle('is-visible', passed && !endVisible);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(apply); ticking = true; }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }

  /* ---------- Renumber every eyebrow in document order ---------- */
  function renumberEyebrows() {
    var nums = document.querySelectorAll('.sk-article .sk-eyebrow .sk-num');
    Array.prototype.forEach.call(nums, function (el, i) {
      el.textContent = i + 1;
    });
  }

  ready(function () {
    try {
      splitHeadings();
      renumberEyebrows();
      trackActive(buildToc());
      progress();
      stickyCta();
    } catch (e) {
      if (window.console) console.warn('[skynz-article]', e);
    }
  });
})();